/** @jsxImportSource @emotion/react */

import React from 'react'
import { Text } from '@components/atoms'
import { ListItemButton } from '@mui/material'
import { useLocation } from 'react-router-dom'

import { MenuType } from '@redux/index'

interface PropsType {
	subMenu: MenuType
	onNavigateClick: (menu: MenuType) => void
}

/** 3깊이 항목 — 점 아이콘 없이 들여쓰기만 */
export const DrawerSubMenuItem = (props: PropsType) => {
	const location = useLocation()
	const isActive: boolean = location.pathname === props.subMenu.to

	return (
		<ListItemButton
			className={`boMenuItem depth3 ${isActive ? 'active' : ''}`}
			onClick={() =>
				props.subMenu.to !== undefined ? props.onNavigateClick(props.subMenu) : {}
			}
		>
			<Text className="boMenuText" as="span" i18n={props.subMenu.i18n}>
				{props.subMenu.name}
			</Text>
		</ListItemButton>
	)
}
